import React from "react";

interface WelcomeMessageProps {
  /** User name to display. If not provided, component renders nothing. */
  name?: string;
  /** Optional className for additional styling */
  className?: string;
}

/**
 * WelcomeMessage component
 * Displays a personalized welcome message with the user's name.
 */
export const WelcomeMessage: React.FC<WelcomeMessageProps> = ({
  name,
  className = "",
}) => {
  if (!name) {
    return null;
  }

  return (
    <h1 className={`text-xl sm:text-2xl font-bold text-gray-800 ${className}`}>
      Bienvenido, <span>{name}</span>
    </h1>
  );
};

